import { render, staticRenderFns } from "./GenericUserName.vue?vue&type=template&id=a10ed474&"
import script from "./GenericUserName.vue?vue&type=script&lang=js&"
export * from "./GenericUserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports